import _ from 'lodash';

/**
 * Filters entities based on the passed in filters. Used by the ListSelector and ListSelectorDialog
 * components to do static searching when an array loader is used for the selector.
 * @param {Object[]} entities
 * @param {{value: string}[]} filters
 * @returns
 */
export function filterEntities(entities, filters, filterProperties = []) {
    const filterString = filters.map((f) => _.trim(f.value)).join(' ');

    if (!_.isEmpty(filterString)) {
        const filterTerms = filterString.toLowerCase().split(/[ ,]+/).filter(Boolean);

        const filtered = _.filter(entities, (entity) => {
            const matchedTerms = _.filter(filterTerms, (filterTerm) => {
                const matchesFields = _.some(filterProperties, (field) => {
                    const value = _.get(entity, field);
                    if (_.isArray(value)) {
                        return _.some(value, (item) => _.isString(item) && _.toLower(item).indexOf(filterTerm) !== -1);
                    }
                    return _.isString(value) && _.toLower(value).indexOf(filterTerm) !== -1;
                });

                if (matchesFields) {
                    return true;
                }
            });

            return matchedTerms.length === filterTerms.length;
        });

        return filtered;
    }

    return entities;
}
